// React ----------------------------------------------------------------//
import React, { useState, useEffect } from "react";
import { useHistory } from "react-router-dom";
// Presenters -----------------------------------------------------------//
import { Alert, Button, Hero } from "../../presenters";

// Components -----------------------------------------------------------//
import PerformanceChartSection from "./performance-chart";
import InvestBannerSection from "./invest-banner";
import PerformanceTableSection from "./performance-table";
import StatisticsTableSection from "./statistics-table";
import PortfolioCompositionSection from "./portfolio-composition";
import LoadingGif from '../../img/loading_pandhora.gif';
import ImageLinkedin from "../../img/linkedin.png";
import ImageWhatsApp from "../../img/whatsapp.png";
import ImageTelegram from "../../img/telegram.png";
import axios from "axios";
import _, { random } from "lodash";

// CSS ------------------------------------------------------------------//
import "./index.css";
import ASSET_CLASSES from "../../asset-classes";

// Utils ---------------------------------------------------------------//
import { API, Backtester, MarketData } from "../../utils";
import Disclaimer from "./disclaimer";



/**
 * Display the results of the simulation with the parameters
 * 
 * chose on the main page.
 *
 * @author Giovanna Marinelli
 */
const Result = (props) => {
    const history = useHistory();
    const shareLink = window.location.href;

    const [copyLink, setCopyLink] = useState({ "pressed": false, "action": false, "text": "Copiar Link" });

    const [launchFirstTime, setlaunchFirstTime] = useState(true);
    const [referenceDate, setReferenceDate] = useState('2016-06-07');

    /**
     * Method to scroll page top
     *
     */
    const scrollPageUp = () => {
        window.scrollTo(0, 0)
    }


    /**
     * First time page load and url has reload=true, page go top
     *
     */
    if (launchFirstTime) {
        // Verify if url has reload=true
        if (performance.getEntriesByType("navigation")[0].type === "reload") {
            scrollPageUp();
        }

        setlaunchFirstTime(false);
    }

    /**
     * Create a portfolio from a set of target weights
     *
     * @param marketData A market data object containing all the necessary
     * market data to generate the portfolio
     * @param targetWeights The target weights on rebalance.
     */
    const createPortfolioFromTargetWeights = (marketData, targetWeights) => {
        // Backtest the portfolio with the specified target weights
        const backtester = new Backtester();
        const portfolio = backtester.createPortfolio(targetWeights, marketData);

        // Add a benchmark
        const benchmark = {};
        Object.keys(marketData.returnsMap).forEach(
            (date) => (benchmark[date] = marketData.returnsMap[date]["CDI"] || 0.0)
        );

        portfolio.setBenchmarkReturns(benchmark);

        // Return the created portfolio
        return portfolio;
    };

    /**
     * Copy and interation buttonn copy.
     * @param shareLink The url with results to be share
        */
    const copyButton = () => {
        navigator.clipboard.writeText(shareLink);
        setCopyLink({ "pressed": true, "text": "Copiado" });
    };

    /**
     * Create a portfolio from the fetched allocation.
     *
     * @param {MarketData} marketData The market data necessary to calculate
     * the portfolio
     * @returns A Portfolio object witht he backtested portfolio
     */
    const createPortfolio = (marketData) => {
        // Create targetWeights from allocation
        const targetWeights = {};
        Object.keys(_.omit(allocation, "id")).forEach(
            (symbol) =>
                (targetWeights[ASSET_CLASSES[symbol].dbName] = allocation[symbol])
        );
        // Return portfolio
        return createPortfolioFromTargetWeights(marketData, targetWeights);
    };

    /**
     * Create a portfolio with allocation without Pandhora LB and Essencial.
     * @param {MarketData} marketData The market data necessary to calculate
     * the portfolio
     */
    const createPortfolioExPandhora = (marketData) => {
        // Create targetWeights from allocation
        const targetWeights = {};
        Object.keys(_.omit(allocationInitial, "id")).forEach(
            (symbol) =>
                (targetWeights[ASSET_CLASSES[symbol].dbName] = allocationInitial[symbol])
        );
        // Distribute pandhora allocation betwehn the other classes that
        // the user have allocation. In the case that the user only chose
        // allocation in pandhora funds, all will be 0.0
        // TODO: Do not hardcode categories.
        const essencial = 'Pandhora Essencial FIC FIM';
        const lb = "Pandhora Long Bias FIC FIM"

        const assetClasses = Object.keys(targetWeights);

        // Find how many classes' allocation are != 0.0
        const pandhoraFunds = new Set([essencial, lb])
        let countCClasses = 0.0;

        assetClasses.forEach((assetClass) => {
            if (targetWeights[assetClass] !== 0.0 && !pandhoraFunds.has(assetClass)) {
                countCClasses++;
            }
        });
        // Sum allocation of LB and Essencial
        const pandhoraAllocation =
            (targetWeights[essencial] +
                targetWeights[lb]);

        // The sum allocation calculate above is reallocated in other asset class,
        //  then Essencial and LB is removed
        assetClasses.forEach((assetClass) => {
            if (targetWeights[assetClass] !== 0.0 && !pandhoraFunds.has(assetClass)) {
                targetWeights[assetClass] /= (1 - pandhoraAllocation);
            }
        });

        // Set pandhora funds allocation to 0
        targetWeights[essencial] = 0.0;
        targetWeights[lb] = 0.0;

        return createPortfolioFromTargetWeights(marketData, targetWeights);
    };

    // Portfolio allocation
    const [allocationInitial, setAllocationInitial] = useState(undefined);
    const [allocation, setAllocation] = useState(undefined);

    // Portfolio allocation type
    const [allocationConfig, setAllocationConfig] = useState(undefined);

    // Indexes data
    const [indexData, setIndexData] = useState(undefined);

    // Fund quotas data
    const [fundData, setFundData] = useState(undefined);

    // Error state
    const [error, setError] = useState(false);

    // Loading State
    const [loading, setLoading] = useState(true);
    const [loading2, setLoading2] = useState(true);
    const [loading3, setLoading3] = useState(true);


    /**
     * Get data given a URL, the data method set to save data received and the reference load
     * @param {url} url Url to get the data
     * @param {setHook} setHook setStatus method to be saved the get result
     * @param {setLoadingHook} setLoadingHook setStatus method to determ if the load is finished
     */
    const fetchData = async (url, setHook, setLoadingHook) => {
        try {
            const result = await axios(url);
            setHook(result.data);
            setLoadingHook(false)
        } catch (e) {
            console.error("Whoopsie!", e);
            setError(true);
        }
    };

    /**
     * Get data given a URL, the data method set to save data received and the reference load
     * @param {url} url Url to get the data
     * @param {setHook} setHook setStatus method to be saved the get result
     * @param {setLoadingHook} setLoadingHook setStatus method to determ if the load is finished
     */
    const fetchDataAllocation = async (url, setHook, setLoadingHook) => {
        try {
            const result = await axios(url);
            if (result.data != undefined) {
                if ((result.data['pandhoraLb'] != 0.0) || result.data['pandhoraLb'] != 0) {
                    setReferenceDate('2019-07-24');
                } else {
                    setReferenceDate('2016-06-07');
                }
            }
            setAllocationConfig({ 'perfil': result.data['perfil'], 'id': result.data['id'] })
            delete result.data['perfil'];
            delete result.data['id'];
            setAllocationInitial(result.data);
            setHook(result.data);
            setLoadingHook(false)

        } catch (e) {
            console.error("Whoopsie!", e);
            setError(true);
        }
    };

    // Fetch allocation
    useEffect(() => {
        const url = `${API.URL}/allocation/${props.match.params.id}`;
        fetchDataAllocation(url, setAllocation, setLoading);
    }, []);

    // Fetch index data
    useEffect(() => {
        const indexIds = Object.keys(ASSET_CLASSES)
            .map((k) => ASSET_CLASSES[k].indexId)
            .filter((e) => e && e !== null)
            .reduce((str, elem) => (str += elem + ","), "")
            .slice(0, -1);
        const url = `${API.URL}/index/daily?ids=${indexIds}`;

        fetchData(url, setIndexData, setLoading2);
    }, []);


    // Fetch fund quotas
    useEffect(() => {
        const fundIds = Object.keys(ASSET_CLASSES)
            .map((k) => ASSET_CLASSES[k].fundId)
            .filter((e) => e && e !== null)
            .reduce((str, elem) => (str += elem + ","), "")
            .slice(0, -1);
        const url = `${API.URL}/fund/daily?ids=${fundIds}`;
        fetchData(url, setFundData, setLoading3);
    }, []);

    let portfolio;
    let portfolioExPandhora;
    let marketData;

    /**
     * Select from a list of dictionary the datas to be used on calculus.
     * @param {datas} datas list of dictionary with all values and reference dates
     * @param {_referenceDate} _referenceDate date to be used as filter(less than equals)
     */
    const removeDatesLTE = (datas, _referenceDate) => {
        let item;
        let arraydata = []
        for (var i in datas) {
            item = datas[i];
            if (item['referenceDate'] >= _referenceDate) {
                arraydata.push(item);
            }
        }
        return arraydata;
    }

    if (fundData && indexData) {

        let indexDataSlice = removeDatesLTE(indexData, referenceDate);
        let fundDataSlice = removeDatesLTE(fundData, referenceDate);

        marketData = new MarketData(indexDataSlice, fundDataSlice);

        portfolio = createPortfolio(marketData);
        portfolioExPandhora = createPortfolioExPandhora(marketData);
    }

    const redirectOnError = () => {
        history.push("/");
    };

    return (
        <div className="Result">
            {loading || loading2 || loading3 ?
                <div className="LoadingGif container">
                    <img src={LoadingGif} style={{ width: "50%", maxWidth: "250px", marginTop: "50px" }} />
                </div> :
                <>
                    {
                        error ? (
                            <React.Fragment >
                                <Alert>
                                    Um erro ocorreu ao calcular o seu resultado. Por favor tente
                                    novamente mais tarde ou contate o administrador da página.
                                </Alert>
                                {setTimeout(redirectOnError, 5000)}
                            </React.Fragment>
                        ) : null
                    }
                    <Hero></Hero>
                    <PerformanceChartSection portfolio={portfolio} portfolioExPandhora={portfolioExPandhora} marketData={marketData} referenceDate={referenceDate}
                        setReferenceDate={setReferenceDate} allocation={allocation} setAllocation={setAllocation} allocationInitial={allocationInitial}
                        allocationConfig={allocationConfig} />
                    <InvestBannerSection />
                    <div className="row-no-gutter">
                        <div className="col">
                            <StatisticsTableSection portfolio={portfolio} portfolioExPandhora={portfolioExPandhora} />
                        </div>
                        <div className="col-lg-12 order-lg-1">
                            <PortfolioCompositionSection portfolio={portfolio} portfolioExPandhora={portfolioExPandhora} />
                        </div>
                    </div>
                    <PerformanceTableSection portfolio={portfolio} portfolioExPandhora={portfolioExPandhora} />
                    <div className="buttonAfterSimulation container">
                        <div style={{ display: "flex", alignItems: "center" }}>
                            <div className="buttonAfterSimulation__item">
                                <span>Compartilhar em </span>
                                <div className="iconsShare">
                                    <img src={ImageLinkedin} alt="linkedin" onClick={() => { window.open("https://www.linkedin.com/sharing/share-offsite/?url=" + shareLink.replace("#", "%23"), '_blank').focus() }} />
                                    <img src={ImageWhatsApp} alt="whatsapp" onClick={() => { window.open("https://wa.me/?text=" + shareLink.replace("#", "%23"), '_blank').focus() }} />
                                    <img src={ImageTelegram} alt="telegram" onClick={() => { window.open("https://t.me/share/url?url=" + shareLink.replace("#", "%23"), '_blank').focus() }} />
                                </div>
                            </div>
                        </div>
                        <div className="buttonAfterSimulation__item">
                            <Button className={"copyLink" + (copyLink.action ? "" : "__action")} id="copyLink" onClick={copyButton}>{copyLink.text}</Button>
                        </div>
                        <div className="buttonAfterSimulation__item">
                            <Button onClick={() => { history.push("/?reload=true") }}>Refazer simulação</Button>
                        </div>
                    </div>
                </>
            }
            <Disclaimer />
        </div >
    );
};

export default Result;
